import FileIcon from './file-icon'
export default {
  install (Vue) {
    Vue.component('FileIcon', FileIcon)
  }
}
